export const tooltipYouAreSavings = (t) => {
    return t('efficientPurchasing.comparative.efficientPurchasing_comparativeSixteen');
};
